import React from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as DatePickerSvg }  from '../../assets/icons/icon_calendar.svg';

const CalendarIcon=(props)=>{
    return <Icon component={() => <DatePickerSvg />} {...props}/>
}

export default CalendarIcon;